import { I18nComponente } from "@/types/gerais"

export const ListaDeUsuariosi18n: I18nComponente = {
  "pt-BR": {
    usuario: "usuário",
    usuarios: "usuários",
    adicionarUsuario: "adicionar usuário",
    ativos: "ativos",
    inativos: "inativos",
    cancelar: "cancelar",
    erroAoDesativarUsuario: "Erro ao desativar usuário",
    naoFoiPossivelDesativarUsuario: "Não foi possível desativar o usuário",
    usuarioDesativadoComSucesso: "Usuário desativado com sucesso!",
    encontreNaAbaInativos: `Encontre-o na aba "inativos"`,
    erroAoAtivarUsuario: "Erro ao ativar usuário",
    naoFoiPossivelAtivarUsuario: "Não foi possível ativar o usuário",
    usuarioAtivadoComSucesso: "Usuário ativado com sucesso!",
    encontreNaAbaAtivos: `Encontre-o na aba "ativos"`,
  },
  "es-CO": {
    usuario: "usuario",
    usuarios: "usuarios",
    adicionarUsuario: "agregar usuario",
    ativos: "activos",
    inativos: "inactivos",
    erroAoDesativarUsuario: "Error al desactivar usuario",
    naoFoiPossivelDesativarUsuario: "No se pudo desactivar el usuario",
    usuarioDesativadoComSucesso: "¡Usuario desactivado con éxito!",
    encontreNaAbaInativos: `Encuéntralo en la pestaña "inactivos"`,
    erroAoAtivarUsuario: "Error al activar usuario",
    naoFoiPossivelAtivarUsuario: "No se pudo activar el usuario",
    usuarioAtivadoComSucesso: "¡Usuario activado con éxito!",
    encontreNaAbaAtivos: `Encuéntralo en la pestaña "activos"`,
  }
}
